  (function () {
    if (window.__productSizeSelectionInit) return; // guard against double-init
    window.__productSizeSelectionInit = true;

    function initProductSizeSelection() {
      const sizeOptionsContainers = document.querySelectorAll('.size-options');

      sizeOptionsContainers.forEach(function (ul) {
        const newUl = ul.cloneNode(true);
        ul.parentNode.replaceChild(newUl, ul);

        const productId = newUl.getAttribute('data-product-id');

        if (!productId) {
          console.warn('No product ID found for size options container');
          return;
        }

        const atcBtn = document.querySelector(`#atc-btn-${productId}`);
        const atcText = document.querySelector(`#atc-text-${productId}`);

        if (!atcBtn || !atcText) {
          console.warn(`Missing ATC elements for product ${productId}`);
          return;
        }

        const initiallySelected = newUl.querySelector('li.size-option.selected');
        if (initiallySelected) {
          const variantId = initiallySelected.getAttribute('data-variant-id');
          const available = initiallySelected.getAttribute('data-available') === 'true';
          atcBtn.setAttribute('data-variant-id', variantId);
          if (!available) {
            updateAtcButtonToSoldOut(atcBtn, atcText);
          }
        } else {
          const firstAvailable = newUl.querySelector("li.size-option[data-available='true']");
          if (firstAvailable) {
            firstAvailable.classList.add('selected');
            const variantId = firstAvailable.getAttribute('data-variant-id');
            atcBtn.setAttribute('data-variant-id', variantId);
          }
        }

        newUl.addEventListener('click', function (e) {
          const sizeOption = e.target.closest('li.size-option');

          if (sizeOption) {
            const variantId = sizeOption.getAttribute('data-variant-id');
            const available = sizeOption.getAttribute('data-available') === 'true';

            newUl.querySelectorAll('li.size-option').forEach((li) => {
              li.classList.remove('selected');
            });
            sizeOption.classList.add('selected');

            atcBtn.setAttribute('data-variant-id', variantId);

            if (available) {
              atcBtn.classList.remove('disable', 'disabled');
              atcBtn.removeAttribute('disabled');
              if (typeof atcText.innerHTML !== 'undefined') {
                atcText.innerHTML = window.__atcTemplates.available;
              }
            } else {
              updateAtcButtonToSoldOut(atcBtn, atcText);
            }
          }
        });
      });
    }

    function updateAtcButtonToSoldOut(button, textElement) {
      button.classList.add('disable');
      button.setAttribute('disabled', 'true');
      if (typeof textElement.innerHTML !== 'undefined') {
        textElement.innerHTML = window.__atcTemplates.soldOut;
      }
    }

    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = function () {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    const debouncedInitRecentlyViewed = debounce(initProductSizeSelection, 300);

    document.addEventListener('DOMContentLoaded', function () {
      initProductSizeSelection();
    });

    document.addEventListener('ajaxComplete', debouncedInitRecentlyViewed);
    document.addEventListener('fetch-complete', debouncedInitRecentlyViewed);
    document.addEventListener('products-loaded', debouncedInitRecentlyViewed);
    document.addEventListener('shopify:section:load', debouncedInitRecentlyViewed);
    document.addEventListener('shopify:block:select', debouncedInitRecentlyViewed);

    const observer = new MutationObserver(function (mutations) {
      let shouldReinit = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const hasNewProducts = Array.from(mutation.addedNodes).some((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;
            return (
              node.querySelector &&
              (node.querySelector('.size-options') ||
                node.classList?.contains('size-options') ||
                node.querySelector('.product') ||
                node.classList?.contains('product'))
            );
          });

          if (hasNewProducts) shouldReinit = true;
        }
      });

      if (shouldReinit) debouncedInitRecentlyViewed();
    });

    setTimeout(function () {
      observer.observe(document.body, { childList: true, subtree: true });
    }, 1000);

    window.reinitProductSelection = function () {
      initProductSizeSelection();
    };

    window.debugProductSelection = function () {
      document.querySelectorAll('.size-options').forEach((container, i) => {
        const productId = container.getAttribute('data-product-id');
        console.log(`Container ${i}: Product ID = ${productId}`);
        console.log(`  - Size options: ${container.querySelectorAll('li.size-option').length}`);
        console.log(`  - Selected: ${container.querySelectorAll('li.size-option.selected').length}`);
      });
    };
  })();
